import $foreign from "./foreign.cjs";
var emptyDelayed = $foreign.emptyDelayed;
var pushDelayed = $foreign.pushDelayed;
var sequenceEffects = $foreign.sequenceEffects;
var unsafeFreezeDelayed = $foreign.unsafeFreezeDelayed;
export { emptyDelayed, pushDelayed, sequenceEffects, unsafeFreezeDelayed };
